import pathConfig from '@ps/bridge/path'
import { fileSave } from '@ps/api/editor/file'

/**
 * 保存资源映射表
 */
export async function saveGlobalUrlMap({
  projectKey,
  uuid2url
}: {
  // 项目 id
  projectKey: number
  // 资源映射表，一般是从素材保重的 qc.assets._uuid2UrlConf 获取
  uuid2url: { [uuid: string]: string }
}) {
  if (uuid2url === null || typeof uuid2url === 'undefined') {
    throw new Error('uuid2url为空')
  }

  const globalUrlMapData =
    'window.urlMapConfig = ' + JSON.stringify(uuid2url, null, 2)
  const globalUrlMapPath = pathConfig.GLOBAL_URL_MAP
  const res = await fileSave({
    projectKey,
    path: globalUrlMapPath,
    binContent: globalUrlMapData
  })
  return res
}
